import { LocaleTranslationResource } from "ui/locale/i18n.types";

export enum RecoverPasswordTabs {
    EMAIL,
    SUCCESS,
}

export type RegisterTabsTitles = Record<RecoverPasswordTabs, LocaleTranslationResource>;

export const RECOVER_PASSWORD_TABS_TITLES: RegisterTabsTitles = {
    [RecoverPasswordTabs.EMAIL]: "password",
    [RecoverPasswordTabs.SUCCESS]: "success",
};
